<template>
  <li class="el-timeline-item" style="display: flex;">
    <!-- <div class="el-timeline-item__tail"></div> -->
    <div
      v-if="!$slots.dot"
      class="el-timeline-item__node"
      :class="[
        `el-timeline-item__node--${size || ''}`,
        `el-timeline-item__node--${type || ''}`
      ]"
      :style="{
        backgroundColor: color
      }"
    >
      <i
        v-if="icon"
        class="el-timeline-item__icon"
        :class="icon"
      ></i>
    </div>
    <div v-if="$slots.dot" class="el-timeline-item__dot">
      <slot name="dot"></slot>
    </div>

    <div class="el-timeline-item__wrapper p-r">
      <div
        v-if="!hideTimestamp && placement === 'top'"
        class="el-timeline-item__timestamp is-top">
        {{timestamp}}
      </div>

      <div class="el-timeline-item__content">
        <slot></slot>
      </div>

      <div
        v-if="!hideTimestamp && placement === 'bottom'"
        class="el-timeline-item__timestamp is-bottom">
        {{timestamp}}
      </div>
    </div>
    <div class="item_tail f--c">
      <div></div>
    </div>
  </li>
</template>

<script>
export default {
  name: 'ElTimelineItem',

  inject: ['timeline'],

  props: {
    timestamp: String,

    hideTimestamp: {
      type: Boolean,
      default: false
    },

    placement: {
      type: String,
      default: 'bottom'
    },

    type: String,

    color: String,

    size: {
      type: String,
      default: 'normal'
    },

    icon: String
  }
}
</script>

<style lang="scss" scoped>
.item_tail {
  height: 12px;
  margin: 0 8px 0 2px;
  >div {
    height: 1px;
    width: 80px;
    background-color: #E4E7ED;
  }
}
.el-timeline-item__wrapper{
  padding-left: 20px !important;
  .el-timeline-item__timestamp{
    position: absolute;
    top: 26px;
    left: 0;
    min-width: 140px;
  }
}
</style>
